<mat-progress-bar class="barra-progreso" mode="indeterminate"  *ngIf="cargandoModulo.isLoading()"></mat-progress-bar>
<router-outlet></router-outlet>